var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dashboard-container" }, [
      _c("div", { staticClass: "welcome" }, [_vm._v("WELCOME")]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v("欢迎进入Supernote管理系统"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }